import { HoldBadge, fmtDateTime, fmtDate } from "@/components/common";
import { CheckCircle, Circle, MapPin } from "@phosphor-icons/react";

const STAGES = [
  { key: "placed", label: "Order placed" },
  { key: "preparing", label: "Preparing shipment" },
  { key: "dispatched", label: "Dispatched — handed to courier" },
  { key: "in_transit", label: "In transit" },
  { key: "arrived", label: "Arrived at destination" },
  { key: "delivered", label: "Delivered" },
];
const RANK = { not_shipped: 0, placed: 0, preparing: 1, dispatched: 2, in_transit: 3, arrived: 4, delivered: 5 };

const firstEventAt = (events, status) => events.find((e) => e.status === status)?.ts || null;

export const TrackingTimeline = ({ shipment: s, orderCreatedAt, compact = false }) => {
  const events = s?.events || [];
  const current = RANK[s?.status] ?? 1;
  const trk = ["fedex", "ups"].includes(s?.carrier) ? s[s.carrier] : null;
  const scans = (trk?.scans || []).slice(0, 3);
  const dates = {
    placed: orderCreatedAt || s?.created_at,
    preparing: firstEventAt(events, "preparing") || s?.created_at,
    dispatched: firstEventAt(events, "dispatched"),
    in_transit: firstEventAt(events, "in_transit"),
    arrived: firstEventAt(events, "arrived"),
    delivered: firstEventAt(events, "delivered"),
  };
  return (
    <div data-testid={`tracking-timeline-${s?.shipment_number || "order"}`}>
      {(s?.dispatch_hold?.active || trk?.eta) && (
        <div className="flex flex-wrap items-center gap-2 mb-3">
          <HoldBadge shipment={s} testid={`timeline-hold-${s.shipment_number}`} />
          {trk?.eta && <span className="text-xs text-muted-foreground" data-testid="timeline-eta">Courier ETA {fmtDate(trk.eta)}</span>}
        </div>
      )}
      <ol className="relative border-l-2 border-border ml-2.5">
        {STAGES.map((st, i) => {
          const done = i <= current;
          const active = i === current;
          return (
            <li key={st.key} className={`relative pl-6 ${compact ? "pb-3" : "pb-5"} last:pb-0`} data-testid={`timeline-stage-${st.key}`} data-state={active ? "active" : done ? "done" : "pending"}>
              <span className={`absolute -left-[11px] top-0 rounded-full bg-card ${active ? "text-primary" : done ? "text-emerald-600" : "text-muted-foreground/40"}`}>
                {done ? <CheckCircle size={20} weight={active ? "fill" : "regular"} /> : <Circle size={20} />}
              </span>
              <p className={`text-sm leading-5 ${active ? "font-semibold text-foreground" : done ? "text-foreground" : "text-muted-foreground"}`}>{st.label}</p>
              {dates[st.key] && done && <p className="text-xs text-muted-foreground">{fmtDateTime(dates[st.key])}</p>}
              {active && scans.length > 0 && (
                <ul className="mt-2 space-y-1.5" data-testid="timeline-scans">
                  {scans.map((ev, k) => (
                    <li key={k} className="text-xs flex items-start gap-1.5 text-muted-foreground">
                      <MapPin size={12} className="mt-0.5 shrink-0 text-primary" />
                      <span><span className="text-foreground">{ev.desc}</span>{ev.location ? ` · ${ev.location}` : ""}{ev.ts ? ` · ${fmtDateTime(ev.ts)}` : ""}</span>
                    </li>
                  ))}
                </ul>
              )}
            </li>
          );
        })}
      </ol>
    </div>
  );
};
